import {
  Home,
  DocumentAdd,
  Chemistry,
  CheckmarkOutline,
  UserMultiple,
  Report,
  Settings,
  Task,
  OverflowMenuHorizontal,
} from "@carbon/icons-react";

export const navigationIcons = {
  home: Home,
  order: DocumentAdd,
  results: Chemistry,
  validation: CheckmarkOutline,
  patient: UserMultiple,
  reports: Report,
  settings: Settings,
  workplan: Task,
  more: OverflowMenuHorizontal,
};
